import React from 'react';
import {
  TIMEZONE_GROUPS,
  ALL_KNOWN_ZONES,
  labelForZone,
  detectBrowserTimezone,
} from '../utils/timezones';

// Shared timezone picker used by the intake-review form and the Portal
// companion-settings page (#660). Renders as a grouped <select> with
// the browser-detected zone surfaced at the top when it's not already
// in the curated list — that way a family member doing intake from
// New York for a relative also in New York doesn't have to scroll.
//
// Value contract: the empty string ('') means "no override, fall back
// to the language-derived default." Both call sites treat that the
// same way at submit (post `null` to clear the column).
//
// We don't bake in a free-text "Other..." path. The curated list plus
// the auto-detected zone covers >99% of users we'll have for the
// foreseeable future; an obscure zone can be set via SQL in the rare
// case the family member needs it. If real demand surfaces, add the
// free-text option here rather than in both consumer pages.
export default function TimezoneSelect({ value, onChange, includeNoOverride = true }) {
  const browserTz = detectBrowserTimezone();
  const browserNotInList = browserTz && !ALL_KNOWN_ZONES.includes(browserTz);

  return (
    <select value={value || ''} onChange={e => onChange(e.target.value || null)}>
      {includeNoOverride && (
        <option value="">Use language default</option>
      )}
      {browserNotInList && (
        <optgroup label="Detected by browser">
          <option value={browserTz}>{labelForZone(browserTz)}</option>
        </optgroup>
      )}
      {TIMEZONE_GROUPS.map(group => (
        <optgroup key={group.label} label={group.label}>
          {group.zones.map(zone => (
            <option key={zone} value={zone}>{labelForZone(zone)}</option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
